export default __webpack_public_path__ + "static/media/Conectividad.8629bfbf.pdf";